import BaseAdderWidget from 'app/components/forms/base_adder_widget/component'
import { nullValidator, withValidation } from 'app/components/forms/util'

const AdderWidget = withValidation(BaseAdderWidget, nullValidator)

export default AdderWidget
